export function normalizeConfidentialIdentifiers(value?: string): string {
    return (value || '')
        .split(/[\r\n,;]+/)
        .map((identifier) => identifier.trim())
        .filter(Boolean)
        .join('\n');
}
